import React, { useState } from "react";
import { FaLink } from "react-icons/fa";
import gallery1 from "../../Assets/Hompage/gallery/gallery (1).jpg";
import gallery2 from "../../Assets/Hompage/gallery/gallery (2).jpg";
import gallery3 from "../../Assets/Hompage/gallery/gallery (3).jpg";
import gallery4 from "../../Assets/Hompage/gallery/gallery (4).jpg";
import gallery5 from "../../Assets/Hompage/gallery/gallery (5).jpg";
import gallery6 from "../../Assets/Hompage/gallery/gallery (6).jpg";
import gallery7 from "../../Assets/Hompage/gallery/gallery (7).jpg";
import gallery8 from "../../Assets/Hompage/gallery/gallery (8).jpg";
import gallery9 from "../../Assets/Hompage/gallery/gallery (9).jpg";
import gallery10 from "../../Assets/Hompage/gallery/gallery (10).jpg";
import gallery11 from "../../Assets/Hompage/gallery/gallery (11).jpg";
import gallery12 from "../../Assets/Hompage/gallery/gallery (12).jpg";
import gallery13 from "../../Assets/Hompage/gallery/gallery (13).jpg";
import gallery14 from "../../Assets/Hompage/gallery/gallery (14).jpg";
import gallery15 from "../../Assets/Hompage/gallery/gallery (15).jpg";
import gallery16 from "../../Assets/Hompage/gallery/gallery (16).jpg";
import gallery17 from "../../Assets/Hompage/gallery/gallery (17).jpg";
import gallery18 from "../../Assets/Hompage/gallery/gallery (18).jpg";
import gallery19 from "../../Assets/Hompage/gallery/gallery (19).jpg";
import gallery20 from "../../Assets/Hompage/gallery/gallery (20).jpg";
import gallery21 from "../../Assets/Hompage/gallery/gallery (21).jpg";
import gallery22 from "../../Assets/Hompage/gallery/gallery (22).jpg";
import gallery23 from "../../Assets/Hompage/gallery/gallery (23).jpg";
import gallery24 from "../../Assets/Hompage/gallery/gallery (24).jpg";
import gallery25 from "../../Assets/Hompage/gallery/gallery (25).jpg";
import gallery26 from "../../Assets/Hompage/gallery/gallery (26).jpg";
import gallery27 from "../../Assets/Hompage/gallery/gallery (27).jpg";
import gallery28 from "../../Assets/Hompage/gallery/gallery (28).jpg";
import gallery29 from "../../Assets/Hompage/gallery/gallery (29).jpg";
import gallery30 from "../../Assets/Hompage/gallery/gallery (30).jpg";
import gallery31 from "../../Assets/Hompage/gallery/gallery (31).jpg";
import gallery32 from "../../Assets/Hompage/gallery/gallery (32).jpg";
import gallery33 from "../../Assets/Hompage/gallery/gallery (33).jpg";
import gallery34 from "../../Assets/Hompage/gallery/gallery (34).jpg";
import gallery35 from "../../Assets/Hompage/gallery/gallery (35).jpg";
import gallery36 from "../../Assets/Hompage/gallery/gallery (36).jpg";
import gallery37 from "../../Assets/Hompage/gallery/gallery (37).jpg";
import gallery38 from "../../Assets/Hompage/gallery/gallery (38).jpg";
const ImageGallery = () => {
  const [imageToShow, setImageToShow] = useState("");
  const [lightboxDisplay, setLightBoxDisplay] = useState(false);

  const image1 = gallery1;
  const image2 = gallery2;
  const image3 = gallery3;
  const image4 = gallery4;
  const image5 = gallery5;
  const image6 = gallery6;
  const image7 = gallery7;
  const image8 = gallery8;
  const image9 = gallery9;
  const image10 = gallery10;
  const image11 = gallery11;
  const image12 = gallery12;
  const image13 = gallery13;
  const image14 = gallery14;
  const image15 = gallery15;
  const image16 = gallery16;
  const image17 = gallery17;
  const image18 = gallery18;
  const image19 = gallery19;
  const image20 = gallery20;
  const image21 = gallery21;
  const image22 = gallery22;
  const image23 = gallery23;
  const image24 = gallery24;
  const image25 = gallery25;
  const image26 = gallery26;
  const image27 = gallery27;
  const image28 = gallery28;
  const image29 = gallery29;
  const image30 = gallery30;
  const image31 = gallery31;
  const image32 = gallery32;
  const image33 = gallery33;
  const image34 = gallery34;
  const image35 = gallery35;
  const image36 = gallery36;
  const image37 = gallery37;
  const image38 = gallery38;

  const images = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image17,
    image18,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
    image31,
    image32,
    image33,
    image34,
    image35,
    image36,
    image37,
    image38,
  ];

  //function to show a specific image in the lightbox, amd make lightbox visible
  const showImage = (image) => {
    setImageToShow(image);
    setLightBoxDisplay(true);
  };

  //hide lightbox
  const hideLightBox = () => {
    setLightBoxDisplay(false);
  };

  //show next image in lightbox
  const showNext = (e) => {
    e.stopPropagation();
    let currentIndex = images.indexOf(imageToShow);
    if (currentIndex >= images.length - 1) {
      setLightBoxDisplay(false);
    } else {
      let nextImage = images[currentIndex + 1];
      setImageToShow(nextImage);
    }
  };

  //show previous image in lightbox
  const showPrev = (e) => {
    e.stopPropagation();
    let currentIndex = images.indexOf(imageToShow);
    if (currentIndex <= 0) {
      setLightBoxDisplay(false);
    } else {
      let nextImage = images[currentIndex - 1];
      setImageToShow(nextImage);
    }
  };
  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-10">
        {/* image card 1 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image1)}
            src={image1}
            alt=""
          />
          <div className="nahid-title flex justify-center">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image1)}
            />
            {/* <h1 onClick={() => showImage(image1)} className='hover:cursor-pointer text-center'>Web Designer <span>Nahid</span></h1> */}
          </div>
        </div>
        {/* image card 2 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image2)}
            src={image2}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image2)}
            />
          </div>
        </div>
        {/* image card 3 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image3)}
            src={image3}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image3)}
            />
          </div>
        </div>
        {/* image card 4 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image4)}
            src={image4}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image4)}
            />
          </div>
        </div>
        {/* image card 5 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image5)}
            src={image5}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image5)}
            />
          </div>
        </div>
        {/* image card 6 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image6)}
            src={image6}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image6)}
            />
          </div>
        </div>
        {/* image card 7 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image7)}
            src={image7}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image7)}
            />
          </div>
        </div>
        {/* image card 8 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image8)}
            src={image8}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image8)}
            />
          </div>
        </div>
        {/* image card 9 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image9)}
            src={image9}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image9)}
            />
          </div>
        </div>
        {/* image card 10 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image10)}
            src={image10}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image10)}
            />
          </div>
        </div>
        {/* image card 11 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image11)}
            src={image11}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image11)}
            />
          </div>
        </div>
        {/* image card 12 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image12)}
            src={image12}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image12)}
            />
          </div>
        </div>
        {/* image card 13 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image13)}
            src={image13}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image13)}
            />
          </div>
        </div>
        {/* image card 14 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image14)}
            src={image14}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image14)}
            />
          </div>
        </div>
        {/* image card 15 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image15)}
            src={image15}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image15)}
            />
          </div>
        </div>
        {/* image card 16 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image16)}
            src={image16}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image16)}
            />
          </div>
        </div>
        {/* image card 17 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image17)}
            src={image17}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image17)}
            />
          </div>
        </div>
        {/* image card 18 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image18)}
            src={image18}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image18)}
            />
          </div>
        </div>
        {/* image card 19 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image19)}
            src={image19}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image19)}
            />
          </div>
        </div>
        {/* image card 20 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image20)}
            src={image20}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image20)}
            />
          </div>
        </div>
        {/* image card 21 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image21)}
            src={image21}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image21)}
            />
          </div>
        </div>
        {/* image card 22 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image22)}
            src={image22}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image22)}
            />
          </div>
        </div>
        {/* image card 23 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image23)}
            src={image23}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image23)}
            />
          </div>
        </div>
        {/* image card 24 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image24)}
            src={image24}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image24)}
            />
          </div>
        </div>
        {/* image card 25 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image25)}
            src={image25}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image25)}
            />
          </div>
        </div>
        {/* image card 26 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image26)}
            src={image26}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image26)}
            />
          </div>
        </div>
        {/* image card 27 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image27)}
            src={image27}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image27)}
            />
          </div>
        </div>
        {/* image card 28 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image28)}
            src={image28}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image28)}
            />
          </div>
        </div>
        {/* image card 29 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image29)}
            src={image29}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image29)}
            />
          </div>
        </div>
        {/* image card 30 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image30)}
            src={image30}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image30)}
            />
          </div>
        </div>
        {/* image card 31 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image31)}
            src={image31}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image31)}
            />
          </div>
        </div>
        {/* image card 32 */}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image32)}
            src={image32}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image32)}
            />
          </div>
        </div>
        {/* image card 33*/}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image33)}
            src={image33}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image33)}
            />
          </div>
        </div>
        {/* image card 34*/}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image34)}
            src={image34}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image34)}
            />
          </div>
        </div>
        {/* image card 35*/}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image35)}
            src={image35}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image35)}
            />
          </div>
        </div>
        {/* image card 36*/}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image36)}
            src={image36}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image36)}
            />
          </div>
        </div>
        {/* image card 37*/}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image37)}
            src={image37}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image37)}
            />
          </div>
        </div>
        {/* image card 38*/}
        <div className="bg-white nahid-img-effect relative hover:border hover:border-[#df3708]">
          <img
            className="image-card shadow-lg p-2"
            onClick={() => showImage(image38)}
            src={image38}
            alt=""
          />
          <div className="nahid-title">
            <FaLink
              className="text-[#df3708] text-5xl hover:cursor-help"
              onClick={() => showImage(image38)}
            />
          </div>
        </div>

        {/* {imageCards} */}
      </div>

      {lightboxDisplay ? (
        <div id="lightbox" onClick={hideLightBox} className="relative">
          <button className="bg-[#df3708] md:ml-10 md:px-2" onClick={showPrev}>
            ⭠
          </button>
          <img id="lightbox-img" src={imageToShow} alt=""></img>
          <button className="bg-[#df3708] md:mr-10 md:px-2" onClick={showNext}>
            ⭢
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ImageGallery;
